import script from "./AboutUsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutUsView.vue?vue&type=script&setup=true&lang=ts"

import "./AboutUsView.vue?vue&type=style&index=0&id=f758e620&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f758e620"]])

export default __exports__